(function () {
  'use strict';

  function initSection(section) {
    var dataEl          = section.querySelector('[data-bundle-data]');
    var cards           = section.querySelectorAll('.btabs__card');
    var tabs            = section.querySelectorAll('.btabs__tab');
    var panes           = section.querySelectorAll('.btabs__pane');
    var track           = section.querySelector('[data-track]');
    var dotsWrap        = section.querySelector('[data-dots]');
    var selector        = section.querySelector('[data-selector]');
    var arrowL          = section.querySelector('[data-arrow="left"]');
    var arrowR          = section.querySelector('[data-arrow="right"]');
    var timelineDotsWrap = section.querySelector('.btabs__timeline-dots');
    var timelineFill     = section.querySelector('.btabs__timeline-fill');

    if (!dataEl || !cards.length) return;

    var products;
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!products || !products.length) return;

    var pIdx      = 0;
    var tabName   = 'description';
    var dotCount  = 0;
    var curDot    = 0;
    var isMobile  = false;

    function esc(str) {
      var el = document.createElement('span');
      el.textContent = str;
      return el.innerHTML;
    }

    function checkMobile() {
      isMobile = window.innerWidth < 769;
    }

    function updateScrollMode() {
      checkMobile();
      if (selector) {
        if (!isMobile) {
          if (products.length > 5) {
            selector.classList.add('btabs__selector--scroll');
          } else {
            selector.classList.remove('btabs__selector--scroll');
          }
        } else {
          selector.classList.remove('btabs__selector--scroll');
        }
      }
      buildDots();
    }

    /* ── Product card carousel dots ── */
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (!isMobile || !track || !cards.length) return;

      dotCount = cards.length;

      for (var i = 0; i < dotCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'btabs__dot' + (i === curDot ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + dotCount);
        dot.dataset.dot = i;
        dot.addEventListener('click', onDotClick);
        dotsWrap.appendChild(dot);
      }
    }

    function onDotClick() {
      scrollToCard(parseInt(this.dataset.dot, 10));
    }

    function scrollToCard(index) {
      if (!track || !cards.length) return;
      index = Math.max(0, Math.min(index, cards.length - 1));
      curDot = index;

      if (isMobile) {
        track.scrollTo({ left: index * track.offsetWidth, behavior: 'smooth' });
      } else {
        var card = cards[index];
        var trackR = track.getBoundingClientRect();
        var cardR = card.getBoundingClientRect();
        var offset = cardR.left - trackR.left + track.scrollLeft - (trackR.width - cardR.width) / 2;
        track.scrollTo({ left: offset, behavior: 'smooth' });
      }
      refreshDots();
    }

    function refreshDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.btabs__dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === curDot);
      }
    }

    if (track) {
      var scrollRaf = false;
      track.addEventListener('scroll', function () {
        if (!scrollRaf) {
          requestAnimationFrame(function () {
            if (isMobile && cards.length) {
              var pageW = track.offsetWidth;
              if (pageW > 0) {
                var newDot = Math.round(track.scrollLeft / pageW);
                newDot = Math.max(0, Math.min(newDot, cards.length - 1));
                if (newDot !== curDot) { curDot = newDot; refreshDots(); }
              }
            }
            scrollRaf = false;
          });
          scrollRaf = true;
        }
      }, { passive: true });
    }

    function getScrollAmount() {
      if (!track || !cards.length) return 180;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 16;
      return cards[0].offsetWidth + gap;
    }

    if (arrowL) {
      arrowL.addEventListener('click', function () {
        if (track) track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }
    if (arrowR) {
      arrowR.addEventListener('click', function () {
        if (track) track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    /* ── Timeline dot navigation (mobile info tabs) ── */
    function buildTimeline() {
      if (!timelineDotsWrap) return;
      timelineDotsWrap.innerHTML = '';

      for (var i = 0; i < tabs.length; i++) {
        (function (index, tab) {
          var dot = document.createElement('div');
          dot.className = 'btabs__tdot' + (tab.classList.contains('is-active') ? ' is-active' : '');
          dot.setAttribute('role', 'button');
          dot.setAttribute('tabindex', '0');
          dot.setAttribute('aria-label', tab.textContent.trim());

          var circle = document.createElement('span');
          circle.className = 'btabs__tdot-circle';

          var label = document.createElement('span');
          label.className = 'btabs__tdot-label';
          label.textContent = tab.textContent.trim();

          dot.appendChild(circle);
          dot.appendChild(label);

          dot.addEventListener('click', function () {
            tabs[index].click();
          });

          dot.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              tabs[index].click();
            }
          });

          timelineDotsWrap.appendChild(dot);
        })(i, tabs[i]);
      }
    }

    function getActiveTabIndex() {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function updateTimeline(activeIndex) {
      if (!timelineDotsWrap) return;

      var dots = timelineDotsWrap.querySelectorAll('.btabs__tdot');

      /* Remove active first, force reflow, then re-apply for animation restart */
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.remove('is-active');
      }
      if (dots.length) void timelineDotsWrap.offsetWidth;

      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.remove('is-completed');
        if (i < activeIndex) dots[i].classList.add('is-completed');
        if (i === activeIndex) dots[i].classList.add('is-active');
      }

      if (timelineFill && dots.length > 1) {
        var pct = (activeIndex / (dots.length - 1)) * 100;
        timelineFill.style.width = pct + '%';
      }
    }

    /* ── Content rendering ── */
    function render() {
      var p = products[pIdx];
      if (!p) return;

      if (tabName === 'description') {
        renderDesc(p);
      } else if (tabName === 'specandmanual') {
        renderSpec(p);
      } else {
        renderMeta(p[tabName], tabName);
      }
    }

    function renderDesc(p) {
      var box = section.querySelector('[data-content="description"]');
      if (!box) return;

      if (!p.images || !p.images.length) {
        box.innerHTML = '<div class="btabs__desc-text">' + (p.description || '') + '</div>';
        return;
      }

      var imgs = '';
      for (var i = 0; i < p.images.length; i++) {
        if (i % 8 === 0) {
          if (i !== 0) imgs += '</div>';
          imgs += '<div class="btabs__thumb-page">';
        }
        imgs += '<img class="btabs__thumb' + (i === 0 ? ' is-active' : '') + '" src="' + p.images[i].thumb + '" data-src="' + p.images[i].src + '" alt="' + (p.images[i].alt || '') + '" loading="lazy">';
      }
      imgs += '</div>';

      var html = '<div class="btabs__desc-grid">';
      html += '<div class="btabs__desc-left">';
      html += '<div class="btabs__desc-text">' + (p.description || '') + '</div>';
      html += '<div class="btabs__thumbs-wrap">';
      html += '<button type="button" class="btabs__thumb-arrow btabs__thumb-arrow--prev" aria-label="Previous">&#10094;</button>';
      html += '<div class="btabs__thumbs"><div class="btabs__thumb-slider">' + imgs + '</div></div>';
      html += '<button type="button" class="btabs__thumb-arrow btabs__thumb-arrow--next" aria-label="Next">&#10095;</button>';
      html += '</div></div>';
      html += '<div class="btabs__main-img-wrap"><img class="btabs__main-img" src="' + p.images[0].src + '" alt="' + (p.images[0].alt || '') + '"></div>';
      html += '</div>';

      box.innerHTML = html;

      var mainImg = box.querySelector('.btabs__main-img');
      var thumbs = box.querySelectorAll('.btabs__thumb');
      var prevBtn = box.querySelector('.btabs__thumb-arrow--prev');
      var nextBtn = box.querySelector('.btabs__thumb-arrow--next');

      for (var t = 0; t < thumbs.length; t++) {
        (function (thumb) {
          thumb.addEventListener('click', function () {
            var prev = box.querySelector('.btabs__thumb.is-active');
            if (prev) prev.classList.remove('is-active');
            this.classList.add('is-active');
            mainImg.classList.add('loading');
            var newSrc = this.dataset.src, newAlt = this.alt;
            var loader = new Image();
            loader.onload = function () { mainImg.src = newSrc; mainImg.alt = newAlt; mainImg.classList.remove('loading'); };
            loader.onerror = function () { mainImg.src = newSrc; mainImg.alt = newAlt; mainImg.classList.remove('loading'); };
            loader.src = newSrc;
          });
        })(thumbs[t]);
      }

      if (prevBtn && nextBtn) {
        var slider = box.querySelector('.btabs__thumb-slider');
        var page = 0;
        var totalPages = Math.ceil(p.images.length / 8);

        function updateSlider() {
          slider.style.transform = 'translateX(-' + (page * 100) + '%)';
          prevBtn.style.display = page === 0 ? 'none' : 'flex';
          nextBtn.style.display = page >= totalPages - 1 ? 'none' : 'flex';
        }

        updateSlider();

        prevBtn.onclick = function () {
          if (page > 0) { page--; updateSlider(); }
        };

        nextBtn.onclick = function () {
          if (page < totalPages - 1) { page++; updateSlider(); }
        };
      }
    }

    function renderMeta(content, key) {
      var box = section.querySelector('[data-content="' + key + '"]');
      if (!box) return;

      if (!content) { box.innerHTML = ''; return; }

      if (typeof content === 'string') {
        if (content.indexOf('<') > -1 || content.indexOf('\n') > -1) {
          box.innerHTML = content;
        } else {
          box.innerHTML = '<p>' + esc(content) + '</p>';
        }
        return;
      }

      if (typeof content === 'object' && content !== null) {
        var entries = [];

        if (Array.isArray(content)) {
          for (var i = 0; i < content.length; i++) {
            var item = content[i];
            if (typeof item === 'object' && item !== null) {
              var keys = Object.keys(item);
              for (var k = 0; k < keys.length; k++) {
                entries.push([keys[k], item[keys[k]]]);
              }
            } else {
              entries.push(['', String(item)]);
            }
          }
        } else {
          var objKeys = Object.keys(content);
          for (var j = 0; j < objKeys.length; j++) {
            entries.push([objKeys[j], content[objKeys[j]]]);
          }
        }

        if (!entries.length) { box.innerHTML = ''; return; }

        var html = '<table><tbody>';
        for (var m = 0; m < entries.length; m++) {
          html += '<tr><td>' + esc(entries[m][0]) + '</td><td>' + esc(String(entries[m][1])) + '</td></tr>';
        }
        html += '</tbody></table>';
        box.innerHTML = html;
        return;
      }

      box.innerHTML = '';
    }

    function renderSpec(p) {
      var target = section.querySelector('[data-content="specandmanual"]');
      if (!target) return;

      var source = section.querySelector('.bundle-product-pdf[data-product-id="' + p.id + '"]');
      if (source) {
        target.innerHTML = source.innerHTML;
      } else {
        target.innerHTML = '';
      }
    }

    /* ── Product card clicks ── */
    for (var c = 0; c < cards.length; c++) {
      (function (idx) {
        cards[idx].addEventListener('click', function () {
          if (idx === pIdx) return;
          for (var j = 0; j < cards.length; j++) cards[j].classList.remove('is-active');
          this.classList.add('is-active');
          pIdx = idx;

          if (isMobile) {
            scrollToCard(idx);
          }

          render();

          if (tabName === 'specandmanual') {
            renderSpec(products[pIdx]);
          }
        });
      })(c);
    }

    /* ── Info tab clicks (desktop underline tabs) ── */
    function scrollTabIntoView(tabEl) {
      if (window.innerWidth >= 769) return;
      var parent = tabEl.parentElement;
      if (!parent) return;
      var tabRect = tabEl.getBoundingClientRect();
      var parentRect = parent.getBoundingClientRect();
      var parentCenter = parentRect.left + parentRect.width / 2;
      var tabCenter = tabRect.left + tabRect.width / 2;
      var diff = tabCenter - parentCenter;
      if (Math.abs(diff) > 2) { parent.scrollBy({ left: diff, behavior: 'smooth' }); }
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (tab, index) {
        tab.addEventListener('click', function () {
          var name = tab.dataset.tab;
          if (name === tabName) return;

          for (var j = 0; j < tabs.length; j++) {
            tabs[j].classList.remove('is-active');
            tabs[j].setAttribute('aria-selected', 'false');
          }
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          for (var p = 0; p < panes.length; p++) {
            panes[p].classList.toggle('is-active', panes[p].dataset.pane === name);
          }

          tabName = name;
          scrollTabIntoView(tab);
          updateTimeline(index);
          render();
        });
      })(tabs[t], t);
    }

    /* ── Resize handler ── */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateScrollMode, 200);
    });

    /* ── Init ── */
    updateScrollMode();
    buildTimeline();
    updateTimeline(getActiveTabIndex());
    render();
    renderSpec(products[0]);
  }

  function boot() {
    var sections = document.querySelectorAll('[data-bundle-tabs]');
    for (var i = 0; i < sections.length; i++) {
      if (!sections[i].dataset.btabsInit) {
        sections[i].dataset.btabsInit = '1';
        initSection(sections[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
  }
})();